module.exports = __webpack_public_path__ + "static/img/img03.328cc47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img03.png
// module id = bUUO
// module chunks = 1